import Cookies from "js-cookie";
import { COMPANY_ID, COMPANYNAME, COMPANY_EMPLOYEE_ID, redirectUrl } from "../config";
import { getCookieDomain } from "./helper";

export const switchCompany = (company, navigate = (url) => window.location.assign(url)) => {
  const options = {
    path: "/",
    domain: getCookieDomain(),
    secure: window.location.protocol === "https:",
    sameSite: "lax",
  };
  const values = {
    [COMPANY_ID]: company.company_id,
    [COMPANYNAME]: company.company_name,
    [COMPANY_EMPLOYEE_ID]: company.company_employee_id || "",
  };
  Object.entries(values).forEach(([key, value]) => Cookies.set(key, String(value), options));
  navigate("/");
};

export const createCompanyUrl = () => new URL("/company/on-board", redirectUrl).href;
